// extracted by mini-css-extract-plugin
export default {"mainWrapper":"H59ZUY02sDKwQX89HH-qGg==","mainWrapperPromoBanner":"_70roI2HOmR0F9bsXxFgiIA==","footer":"g+sB6-iv0aMib8ZQwggxFA==","mobileAsBlock":"Hmv15FU5qExDazMF48MD2g=="};